import api from './api';

export const getDesignations = () => {
  return api.get('/designations');
};

export const createDesignation = (designationData) => {
  return api.post('/designations', designationData);
};

export const getDesignation = (id) => {
  return api.get(`/designations/${id}`);
};

export const updateDesignation = (id, designationData) => {
  return api.put(`/designations/${id}`, designationData);
};

export const deleteDesignation = (id) => {
  return api.delete(`/designations/${id}`);
};
